// Libs
import React from 'react';
import { format } from 'date-fns';
import { Box, Typography, Grid } from '@mui/material';

const OrderCardTime = ({
  order,
  isMobileMode,
  gridPropValues,
  classes,
  cx,
}) => (
  <Grid
    item
    flexBasis={gridPropValues({
      lgSize: 2,
      unit: '%',
    })}
    order={gridPropValues({
      lgSize: 6,
      mdSize: 2,
    })}>
    <Box display="flex" flexDirection="column" data-testid="order-time">
      <Typography className={classes.headerText}>Order Time:</Typography>
      {order.created && (
        <div className={cx(classes.text, classes.orderTime)}>
          <div>{format(new Date(order.created), 'M/d/yyy')}</div>
          {isMobileMode && <>,&nbsp;</>}
          <div>{format(new Date(order.created), 'hh:mm a')}</div>
        </div>
      )}
    </Box>
  </Grid>
);

export default OrderCardTime;
